import CustomHead from 'components/commons/CustomHead'
import TopicsAll from 'components/topics/news/page/PageId'
import { wpApiUrl } from 'lib/url'
import { fetchEventPosts } from 'lib/wp'
import WPAPI from 'wpapi'

interface Event {
  id: number
  title: {
    rendered: string
  }
  thumbnail_img?: string
  content: {
    rendered: string
  }
  date: string
  category_name: string
  start_date?: string
  end_date?: string
  duration?: string
}

interface newsIdItems {
  posts: {
    id: number
    title: {
      rendered: string
    }
    content: {
      rendered: string
    }
  }
  page: number
  totalPageNumber: number
  activeEvents?: Event[]
}

const newsId: React.FC<newsIdItems> = ({ posts, page, totalPageNumber, activeEvents }) => (
  <>
    <CustomHead
      keyword={'ニュース 最新情報 プレスリリース イベント セミナー'}
      image={'https://aitria.co.jp/img/ogp_logo.png'}
      url={`https://aitria.co.jp/news/page/${page}`}
      title="ニュース | Aitria（アイトリア）"
      description="Aitria（アイトリア）のニュースページです。最新の情報はこちらからご覧ください。"
    />
    <TopicsAll posts={posts} page={page} totalPageNumber={totalPageNumber} activeEvents={activeEvents} />
  </>
)

interface Props {
  paths: string[]
  fallback: false
}

export async function getStaticPaths(): Promise<Props> {
  const wpnews = new WPAPI({ endpoint: wpApiUrl })
  const header = await wpnews.posts().categories(2).headers()
  const totalPageNumber = parseInt(header['x-wp-totalpages'])
  const pages = Array.from({ length: totalPageNumber }, (_, i) => i + 1)

  const paths = pages.map((page) => `/news/page/${page}`)
  return {
    paths,
    fallback: false,
  }
}

interface Post {
  props: {
    posts: {
      id: number
      title: {
        rendered: string
      }
      content: {
        rendered: string
      }
    }
    page: number
    totalPageNumber: number
    activeEvents?: Event[]
  }
}

export async function getStaticProps({ params }): Promise<Post> {
  const page = parseInt(params.id, 10) || 1
  const wpnews = new WPAPI({ endpoint: wpApiUrl })
  const [header, posts, eventPosts] = await Promise.all([
    wpnews.posts().categories(2).headers(),
    wpnews.posts().categories(2).page(page),
    fetchEventPosts(),
  ])
  const totalPageNumber = parseInt(header['x-wp-totalpages'])

  const currentDate = new Date().toISOString()
  let activeEvents = eventPosts
    .filter((post) => post.end_date && new Date(post.end_date).toISOString() >= currentDate)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 5)

  // サムネイル画像URLを変換し、undefinedをnullに置き換える
  activeEvents = activeEvents.map((event) => {
    const updatedThumbnail = event.thumbnail_img
      ? event.thumbnail_img.split('https://cms-admin.i3design.jp/wp-content/uploads').join('/images/wp')
      : null
    return {
      ...event,
      thumbnail_img: updatedThumbnail,
    }
  })

  return {
    props: {
      posts,
      page,
      totalPageNumber,
      activeEvents,
    },
  }
}

export default newsId
